<main>
  <ng-container *ngFor="let component of injectorArray; trackBy: trackByWidgetLayout">
    @if (configService.getActiveConfigType().isWorkflow) {
      <div
        pDroppable="dd"
        (onDrop)="drop(component.widget, $event)"
        class="main-widget-contents"
        [ngClass]="component.widget.uniqueId === mouseOverId ? mouseOver : ''"
        (click)="selectWidget($event, component.widget)"
        (mouseover)="changeStyle($event, component.widget.uniqueId.toString())"
        (mouseout)="changeStyle($event)"
      >
        <div [class]="getWidgetClasses(component.widget)">
          <ng-container *ngComponentOutlet="component.component; injector: component.injector"></ng-container>
        </div>
      </div>
    } @else {
      <div [class]="getWidgetClasses(component.widget)">
        <ng-container *ngComponentOutlet="component.component; injector: component.injector"></ng-container>
      </div>
    }
  </ng-container>
</main>
